const SubscribeIcon = (props) => (
  <svg
    width='800px'
    height='800px'
    viewBox='0 0 48 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M48 0H0V48H48V0Z' fill='white' fillOpacity={0.01} />
    <path
      d='M43 5L29.7 43L22.1 25.9L5 18.3L43 5Z'
      stroke='currentColor'
      strokeWidth={4}
      strokeLinejoin='round'
    />
    <path
      d='M43.0001 5L22.1001 25.9'
      stroke='currentColor'
      strokeWidth={4}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SubscribeIcon;
